import {
  MedFlowIntegrationConfig,
  MedFlowOperationType,
  MedFlowResourceType,
} from '../interfaces/medFlowIntegration';

/**
 * Indica se uma operação (create/update/delete) é permitida para um recurso
 * MedFlow, a partir da configuração do parceiro
 * (`prescriberConfiguration.Features.medFlowIntegration`).
 *
 * Espelha fielmente a regra do backend (`MedFlowIntegrationFeatureService`:
 * `isEnabled` + `isOperationAllowed`), que é deny-by-default:
 * - `enabled` é portão mestre: se não for `true`, nega tudo;
 * - só libera com `true` explícito em toda a cadeia;
 * - formato legado booleano: `true` libera tudo, o resto nega.
 */
export function isMedFlowOperationAllowed(
  config: MedFlowIntegrationConfig | undefined,
  resourceType: MedFlowResourceType,
  operation: MedFlowOperationType,
): boolean {
  // Ausente/null: integração não habilitada -> nega.
  if (config == null) return false;

  // Formato legado: booleano puro (true = tudo liberado).
  if (typeof config === 'boolean') return config;

  // Portão mestre: precisa estar habilitada.
  if (config.enabled !== true) return false;

  const allowPermissions = config.allowPermissions;
  if (allowPermissions == null) return false;

  const resourcePermissions = allowPermissions[resourceType];
  if (resourcePermissions == null) return false;

  // Somente `true` explícito libera; null/undefined/false negam.
  return resourcePermissions[operation] === true;
}
